module.exports = __webpack_public_path__ + "img/gbWhatsappSupport.3e75fc31.webp";